<div class="container">
  <div class="row">
    <div class="col-md-6" style="color:black; padding-top:1%; font-size:1.4em; font-weight:bold ">
      In re Generic Pharmaceuticals Antitrust Litigation
    </div>
    <div class="col-md-6">
      <div class="float-right phoneNumber" style="font-size: 1.4em; padding-top: 3%; font-weight: bold">1-877-316-0171</div>
    </div>
    <div class="col-md-12" style="padding-left:0px; padding-right:0px">
   
    </div>
  </div>
</div>
<header>
  <nav class="navbar navbar-expand-sm navbar-toggleable-sm navbar-light  border-bottom " style="background-color: #000042 ">
    <div class="container">
      <button class="navbar-toggler" type="button" style="background-color:white" data-toggle="collapse" data-target=".navbar-collapse" aria-label="Toggle navigation" [attr.aria-expanded]="isExpanded" (click)="toggle()">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse justify-content-center" [ngClass]="{ show: isExpanded }">
        <ul class="navbar-nav flex-grow">
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/landing']" style="color:white; font-weight:bold">All Classes Page</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']" [routerLinkActiveOptions]="{ exact: true }">
            <a class="nav-link  hover_lightBlue" [routerLink]="['/apotex-heritage-classes-homepage']" style="color:white; font-weight:bold">Home</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']" [routerLinkActiveOptions]="{ exact: true }">
            <a class="nav-link  hover_lightBlue" [routerLink]="['/home']" style="color:white; font-weight:bold">File a Claim</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link  hover_lightBlue" [routerLink]="['/apotex-heritage-classes-notice']" style="color:white; font-weight:bold">Notice/FAQs</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/apotex-heritage-classes-courtdocuments']" style="color:white; font-weight:bold">Court Documents</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/apotex-heritage-classes-contact']" style="color:white; font-weight:bold">Contact Information</a>
          </li>

        </ul>
      </div>
    </div>
  </nav>

</header>
<div class="container" style="border:1px solid #bebaba">
  <div class="row text-center background-bottom">
    <div class="col-md-12 text-center img-fluid" style="margin-top:2%; margin-bottom:2%; padding-right:2%; padding-left:2%">
      <p class="text-center" style="font-size:1.0em; color:white">
        This official website is maintained by the Notice Administrator for <i>In re Generic Pharmaceuticals Antitrust Litigation</i>,
        No. 16-MD-2724 pending in the United States District Court for the Eastern District of Pennsylvania.
      </p>
    </div>
  </div>
  <!--<div class="row mt-4">
    <div class="col-md-12 text-center">-->
  <!--<img src="../assets/Header wo button.png" class="img-fluid" />-->
  <!--<a [routerLink]="'/tpp'">
        <img src="../assets/Button.png" alt="Register for Updates Here" class="img-fluid" style="width: 30%" />
      </a>
    </div>
  </div>-->
  <div class="row background">
    <div class="col-md-12">
      <a [routerLink]="['/home']">
        <img src="../assets/Main with CTA button.png" class="img-fluid" />
      </a>
    </div>
  </div>
  <!--<div class="row">
    <div class="col-md-12 background">
      <img src="../assets/Generics HA.TPP.jpg" class="img-fluid" />
      <a [routerLink]="'/home'">
        <img src="../assets/Main with CTA button.png.png" alt="Register for Updates Here" class="img-fluid" style="width: 30%; margin-left: 470px; margin-right: -15px; margin-top: -100px; margin-bottom: 4%;" />
      </a>
    </div>
  </div>-->
  <br />
  <div class="row" style="margin-left:5%;margin-right:5%">
    <div class="col-md-12" style="text-align:justify;">
      <div style="text-align:left; font-size:1.5em">
        The Court has granted final approval of two settlements, totaling $58 million, with Settling Defendants Heritage Pharmaceuticals Inc., Emcure Pharmaceuticals Ltd., Satish Mehta, and Apotex Corp., in a class action lawsuit (<i>In re Generic Pharmaceuticals Antitrust Litigation</i>, No. 16-MD-2724 (E.D. Pa.)). The lawsuit claims generic manufacturers violated federal and state antitrust laws, consumer protection statutes, and common law, causing End-Payers – including Third Party Payers (“TPPs”) (e.g., entities such as insurers or employers with self-funded prescription drug plans) – to pay more than they should have for certain generic drugs (“Named Generic Drugs”). The Settling Defendants deny liability. The lawsuit remains ongoing against the Non-Settling Defendants.
        <br /><br />

        To participate in the settlement, you must submit a claim form online or by U.S. Mail so that it is submitted or postmarked by <b>November 9, 2026</b>.
        Click  <a [routerLink]="['/home']">HERE</a> for the claim form. <b>
          Settlement Class members need not sign up with a claims recovery firm or pay
          another firm in order to participate in the settlements
        </b>.<br /><br />
      </div>
    </div>
    <br />
    <br />
    <div class="table-responsive">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th colspan="2" style="background-color: #000042; color: white; font-weight: bold; font-size: 1.4em; text-align: center;">
              YOUR LEGAL RIGHTS AND OPTIONS REGARDING THIS SETTLEMENT
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="background-color: #000042; text-align: center; font-weight: bold; color: white; vertical-align: middle; width: 20% ">
              SUBMIT A CLAIM FORM
            </td>
            <td style="background-color:white; color:#3e4144; width:60%">
              If you want to be eligible to receive money from this Settlement, you must complete and return a Claim Form.
              The Claim Form and information on how to submit it are available <a [routerLink]="['/home']">HERE</a>. (You
              may request that a form be mailed to you by calling 1-877-316-0171.) Claim Forms must be postmarked (if mailed)
              or received (if submitted online) on or before <b>November 9, 2026</b>. If you or a third party requested that you be
              excluded from the Settlement, and if the Court approved that request, then you will not be eligible to receive
              money from the settlement.
            </td>
          </tr>
          <tr>
            <td style="background-color: #000042; text-align: center; font-weight: bold; color: white; vertical-align: middle; ">
              DO NOTHING
            </td>
            <td style="background-color:white; color:#3e4144;">
              If you are a member of the Settlement Class, by doing nothing you will remain in the Settlement Class for this
              Settlement. You will not get a payment from the Settlement and will give up your right to sue Sun or Taro on
              your own for the same legal claims made in this lawsuit. You will be bound by the Settlement.<br /><br />

              The deadline for you to object to this Settlement has passed, and the deadline to request to be excluded, or
              “opted out” of, the Settlement Class has passed.
            </td>
          </tr>
          <tr>
            <td style="background-color: #000042; text-align: center; font-weight: bold; color: white; vertical-align: middle; ">
              GET MORE INFORMATION
            </td>
            <td style="background-color:white; color:#3e4144;">
              If you would like to obtain more information about the Lawsuit or the Settlement, you can review the materials
              on the <a [routerLink]="'/apotex-heritage-classes-courtdocuments'">Court Documents</a>  page, call 1-877-316-0171, or
              send questions to the Notice Administrator at  <a href="mailto:info@genericdrugsendpayersettlement.com">info@genericdrugsendpayersettlement.com</a>.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <br />
  </div>
</div>
